<script setup lang="ts">
import {
    inject, onBeforeUnmount, onMounted, onUpdated, ref, shallowRef, unref, watch,
} from 'vue';

import { NavTabsParentKey } from './injection';
import { useGenerateIdRef } from './nav-tabs';

const props = defineProps<{
    initiallyActive?: boolean;
    title?: string;
    id?: string;
}>();
//eslint-obsolete no-spaced-func
const emit = defineEmits<{
    (event: 'activated', value: undefined): void;
    (event: 'deactivated', value: undefined): void;
    (event: 'toggle', value: boolean): void;
}>();
const active = ref(props.initiallyActive);
const hidden = ref<boolean>();
const element = shallowRef<HTMLElement | undefined>();

const generateIdRef = useGenerateIdRef();
const idRef = generateIdRef(props.id);
const navTabsParent = inject(NavTabsParentKey);
function isHidden() {
    const _element = unref(element);
    //vue v-show
    return !!(_element && (_element.style.display === 'none'));
}

watch(active, (val, old) => {
    if(!!val !== !!old) {
        if(val) emit('activated', undefined); else emit('deactivated', undefined);
        emit('toggle', val ?? false);
    }
});
onMounted(() => {
    hidden.value = isHidden();
    const _element = unref(element);
    if(_element) {
        navTabsParent?.registerPane?.({
            idRef,
            active,
            props,
            hidden,
            element: _element,
        });
    }
});
onBeforeUnmount(() => {
    navTabsParent?.unregisterPane?.(idRef);
});
onUpdated(() => {
    hidden.value = isHidden();
    const _element = unref(element);
    if(_element) {
        navTabsParent?.updatePane?.(idRef, _element);
    }
});
</script>

<template>
    <div
        :id="idRef.tabid"
        ref="element"
        class="tab-pane"
        :class="active ? ['active'] : []"
        role="tabpanel"
        :aria-labelledby="idRef.btnid"
        data-auto-tab-pane
    >
        <div class="panel panel-default rounded-3 bg-body-secondary border border-1 border-primary">
            <div class="panel-body">
                <slot />
            </div>
        </div>
    </div>
</template>
